import { randomNum } from '@pinup-teams/common';

import { SaveRequestEncryptedData, FinancialRequestStatus } from '../../../models';

export function getRequestDetailsEncryptedDataMock(id: string): SaveRequestEncryptedData {
  return {
    requestIdHash: id,
    data: {
      date: new Date(),
      fromUser: id.toString(),
      message: 'Some comment here Some comment here Some comment here Some comment here',
      status: [
        FinancialRequestStatus.New,
        FinancialRequestStatus.InProgress,
        FinancialRequestStatus.Completed,
        FinancialRequestStatus.Rejected,
        FinancialRequestStatus.Canceled,
      ][randomNum(4)],
    },
  };
}
